<template>
  <div v-if="authed" class="flex items-center justify-center w-full">
    <pre class="flex-initial text-xs">
                               -shhys/:+hNMMMMy
                              :NMNNNmdsymmmdmdN/
                              .dNdssyhhddyyysohsss/.:/
                              -.sdhs/-::h/:-:+hh-:dMNMh`
                            `oNMMh:.--/y-----:yooydmdhh.
                            -hdhNy:-.-oy--/+oody:--:smMm.
                            .:.``:m+/+ssd++o/.-h. +s`.mMMy  ``.--..`
                      .::::/y- ./::o:--::-+--:+--oy-:odsyNsoooo//ooso:`
                  ./oo/---:hmys+so/-.-yhhy--::++/::+odNNh/----:-----sh/`````
                .s+:--....-+mMd+--:++/+://///:-..-+/-yNy:-----.------/hooooy+-`
              ..-ho--...--:::oyso+++++/-..-..-::/:/oo+os+:------------.:-.--:/os:`
          ./s/:-/--.....:++/-------:/++/:-:/:---......----------.-----.-....---oo`
        `oo:-..-:......................:+/-...............----....----.-.......-::y`
      //so..---....-/.-................+/......-............---....---..........--so-
      .y:--......-..:o.-...............-s-...-..----------....-+-......-----.......-oy+
    `/+-.........--.-s.................-s....-...---------.....::::/::::-/s:......--::y+
  `o/...............s:..---...........-s........---------.....--:+d+//+/:y:.....--..-:d.
  `s/..........+-..--/s-.-..-.........--o:.......-....-----...-+/-/h      .s:....-..---h+
  ++..........:y::::::oy-.........-...--:s-..-.........-----:/+/--+s       :y:...-...-:ho
  y...-....../y/      `yyo/-........-/++:::--:--......---://+:-../y-       `od/....---/yo
  h...-...--/+.        .+::///////+++/://::::////////+++/:-.....-o/       ./yh/-----.-:h:
  y-...---:+o.          `+:`.-------.///::-/+o+-................-/       `hy+-------.-:y
.s-.-----:-/y           `:/------.-/:-----..-/o/....--....---:o-        `hsso-......-:y
y:--....-o/+h             .///-.-.:o-----.....-o:...-......-:so          +dys-.......:h
y.-.....:soyd`              ./s:-.:+-------..-.-----..--.../h:           :y:------..:s:
::--..-----/d`                .o+.-:----//--.-----------.-oy:             +o+oo+:--/s/
  -+/:./hy+so-                  `+s:---....---------------so                  `````..
    `---:.                        /y.--...--------------:o/         ````
                                  y/--..-------------./y:       `:ydmmdo`
                                  -y:-----------.-----dm:`     :ddsdNNMMo
                                    os:-..------.---::hNsdms/-:yNNy:ommMN:
                                    so---:///:::---yms//omNmyosys+/:hNh.
                                    `y+-::hy++ssy+--oNs:-/++/////+oyys:
                                    /h:::sy     :d:-:dssssyssooo+//-`
                                    y+--:d`     `m/-:h/
                                    so-:/d       d/:+hs
                      `/+oooso-  `:ydh/:/dy+ossshm//sN:
                    /MNhhoossyhhmyo+//:::yNMMMMd+//yNo../oossso/`
                    .mmNssmhooo++///:::::/hMMdo/////ohhhhhyysydmNh`
                      `+oosysssoossssyyysssyyssooooooooooossssyyyyy+
  </pre
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ADMIN_AUTHED } from '@/store/types'
import { meta } from 'dayjob'

export default {
  name: 'AdminBuff',

  metaInfo: {
    title: `${meta.title} Admin`,
    titleTemplate: ''
  },

  computed: {
    ...mapGetters({
      authed: `admin/${ADMIN_AUTHED}`
    })
  }
}
</script>
